import { Box } from "@mui/material";
import { MenuItem, Select, Typography } from "@platform/design-system";

import type { Broker } from "../types";

const ALL_BROKERS = "all";

interface RepBrokerSelectProps {
  brokers: Broker[];
}

export const RepBrokerSelect = ({
  brokers,
}: RepBrokerSelectProps): React.JSX.Element => (
  <Box
    data-testid="rep-broker-select"
    display="flex"
    alignItems="center"
    gap={1}
  >
    <Typography variant="body-medium" component="span">
      Broker
    </Typography>
    <Select defaultValue={ALL_BROKERS} sx={{ minWidth: 200 }}>
      <MenuItem value={ALL_BROKERS}>All brokers</MenuItem>
      {brokers.map(({ id, name }) => (
        <MenuItem key={id} value={id}>
          {name}
        </MenuItem>
      ))}
    </Select>
  </Box>
);
